import JassEnum from './enum';

/**
 * type pathingtype
 */
export default class JassPathingType extends JassEnum {}
